import { runInAction } from "mobx";
import AppStore from "./AppStore";
import ProjectManagent, { IProject } from "../models/Project.model";
import Store from "./Store";
import PersonalDevelopment, { IPersonalDevelopment } from "../models/PersonalDevelopment";

export default class PersonalDevelopmentStore extends Store<IPersonalDevelopment, PersonalDevelopment> {
    items = new Map<string, PersonalDevelopment>();

    constructor(store: AppStore) {
        super(store);
        this.store = store;
    }

    load(items: IPersonalDevelopment[] = []) {
        runInAction(() => {
            items.forEach((item) => {
                this.items.set(item.id, new PersonalDevelopment(this.store, item))
            })
        });
    }
}
